import React from "react"
import { useAppDispatch } from "../../../../../state/store"
import { lightBlack } from "../../../../../themes/variables"
import { CloseButton } from "../../../../../ui/atoms/IconButton/buttons/close"
import Stroke from "../../../../../ui/atoms/Stroke"
import Typography from "../../../../../ui/atoms/Typography"
import { CustomBox } from "../../../../../ui/spacings"
import { formatMoney } from "../../../../../utils/money"
import { useLabels } from "../../../../contents/hooks"
import { removeGiftcard } from "../../../state/actions/giftcardToggle"
import { Basket, BasketRecap } from "../../../state/checkoutTypes"
import ShippingRecapPrice from "./ShippingRecapPrice"

interface Props {
  basket: Basket
}

const getTotal = (recap: BasketRecap) => {
  if (recap.totalToPayLater?.price) {
    return recap.totalToPayLater.price
  }
  if (!!recap.totalToPay?.price) {
    return recap.totalToPay.price
  }
  return undefined
}

const PriceDetailsBox = ({ basket }: Props) => {
  const { getLabel } = useLabels()
  const dispatch = useAppDispatch()

  const handleRemoveGiftcard = (code: string) => dispatch(removeGiftcard(code))

  const completed = !!basket.order?.id
  const basketDiscounts = basket.recap.basketDiscounts.filter(
    (x) => (x.totalDiscount ?? 0) > 0
  )

  const hasGiftcards = basket.items.some((x) => x.type === "giftcard")

  return (
    <div>
      {basketDiscounts.length > 0 && (
        <>
          {basket.recap.basketDiscounts.map((x, index) => (
            <CustomBox
              mt={1}
              mb={2}
              flex="row"
              justifyContent="space-between"
              key={index}
            >
              <Typography variant="body1">
                {x.id === "voucher"
                  ? getLabel("basket", "voucher-discount")
                  : getLabel("basket", "price-discount")}{" "}
                {x.name}
              </Typography>
              <Typography variant="body1" color="error" weight="bold">
                {formatMoney({
                  amount: -(x.totalDiscount as number),
                  currency: "eur",
                  currencyPosition: "after",
                })}
              </Typography>
            </CustomBox>
          ))}
          <Stroke color="disabled" />
        </>
      )}
      <CustomBox my={1} flex="row" justifyContent="space-between">
        <Typography variant="body1">
          {getLabel("basket", "price-subtotal")}
        </Typography>
        <Typography variant="body1">
          {formatMoney({
            amount: basket.recap.subtotal.price,
            currency: "eur",
            currencyPosition: "after",
          })}
        </Typography>
      </CustomBox>

      {!hasGiftcards && (
        <CustomBox
          my={1}
          flex="row"
          justifyContent="space-between"
          alignItems="flex-start"
        >
          <Typography variant="body1">
            {getLabel("basket", "price-shipping")}
          </Typography>
          <ShippingRecapPrice basket={basket} />
        </CustomBox>
      )}

      {basket.recap.currierPaymentPrice?.price && (
        <CustomBox my={1} flex="row" justifyContent="space-between">
          <Typography variant="body1">
            {getLabel("basket", "price-currier-payment")}
          </Typography>
          <Typography variant="body1">
            {formatMoney({
              amount: basket.recap.currierPaymentPrice.price,
              currency: "eur",
              currencyPosition: "after",
            })}
          </Typography>
        </CustomBox>
      )}

      {basket.recap.giftcards?.length > 0 && (
        <div className="mt-4">
          <Stroke color="disabled" />
          {basket.recap.giftcards.map((x) => (
            <CustomBox
              key={x.code}
              my={1}
              flex="row"
              justifyContent="space-between"
            >
              <div className="flex items-center">
                <Typography variant="body1" className="mr-3">
                  {getLabel("basket", "price-giftcard")} {x.code.toUpperCase()}
                </Typography>
                {!completed && (
                  <CloseButton
                    color={lightBlack}
                    onClick={() => handleRemoveGiftcard(x.code)}
                    size={20}
                  />
                )}
              </div>
              <Typography variant="body1">
                {formatMoney({
                  amount: -(x.usedAmount as number),
                  currency: "eur",
                  currencyPosition: "after",
                })}
              </Typography>
            </CustomBox>
          ))}
        </div>
      )}

      {basket.recap.totalToPay && (
        <div className="mt-4">
          <Stroke color="disabled" />
          <CustomBox my={1} flex="row" justifyContent="space-between">
            <Typography variant="subtitle2" weight="bold">
              {getLabel("basket", "price-total")}
            </Typography>
            <Typography variant="subtitle1">
              {formatMoney({
                amount: getTotal(basket.recap),
                currency: "eur",
                currencyPosition: "after",
              })}
            </Typography>
          </CustomBox>
        </div>
      )}

      {/* <CustomBox my={1} flex="row" justifyContent="space-between">
        <Typography variant="body1" weight="bold">
          Tasse
        </Typography>
        <Typography variant="body1">incluse</Typography>
      </CustomBox> */}
      {/*
      <Stroke />
      <CustomBox my={2} flex="row" justifyContent="space-between">
        <Typography weight="bold">Totale (IVA inclusa)</Typography>
        <Typography weight="bold">
          {formatMoney({
            amount: basket.recap.total.price,
            currency: "eur",
            currencyPosition: "after",
          })}
        </Typography>
      </CustomBox> */}
    </div>
  )
}

export default PriceDetailsBox
